import React from "react";
import { Button, useTheme } from "@mui/material";

const LargeButton = ({ label, onClick, disabled = false }) => {

    const theme = useTheme();
    return (
        <Button
            variant="contained"
            color="primary"
            size="small"
            disabled={disabled}
            type="button"
            onClick={onClick}
            sx={{
                height: "60px",
                padding: "0 30px",
                fontSize: "1.2rem",
            }}
        >
            {label}
        </Button>
    );
}

export default LargeButton;
